export default "__VITE_ASSET__5cc35851__"